import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console but don't crash the app
    console.error('Error caught by boundary:', error, errorInfo);
    
    // Ignore browser extension errors
    if (error?.message?.includes('conflux') || 
        error?.message?.includes('chrome-extension') ||
        error?.message?.includes('Cannot redefine property')) {
      // Reset error state for extension errors
      this.setState({ hasError: false, error: null });
      return;
    }
  }

  render() {
    if (this.state.hasError && 
        !this.state.error?.message?.includes('conflux') &&
        !this.state.error?.message?.includes('chrome-extension')) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Niečo sa pokazilo</h2>
          <p>Prosím, obnovte stránku</p>
          <button onClick={() => window.location.reload()}>
            Obnoviť stránku
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;